module.exports = __webpack_public_path__ + "img/circle-ico.f7c48a77.svg";